export default {
    list: {
        title: "Container",
        subtitle: "Gestisci i tuoi container",
        newContainer: "Nuovo Container",
        viewMap: "Vedi Mappa",
        loading: "Caricamento container...",
        clearFilters: "Pulisci Filtri",
        backToDashboard: "Torna alla Dashboard",
        filters: {
            searchPlaceholder: "Cerca per numero container, route...",
            statusPlaceholder: "Filtra per stato",
            riskLevelPlaceholder: "Filtra per livello rischio",
            documentStatusPlaceholder: "Filtra per stato documenti",
            shippingCompanyPlaceholder: "Filtra per compagnia",
            commodityPlaceholder: "Filtra per commodity",
            originPlaceholder: "Filtra per origine",
            portPlaceholder: "Filtra per porto arrivo",
            allStatuses: "Tutti gli stati",
            allLevels: "Tutti i livelli",
            allCompanies: "Tutte le compagnie",
            allCommodities: "Tutte le commodity",
            allOrigins: "Tutte le origini",
            allPorts: "Tutti i porti",
        },
        table: {
            title: "Container",
            description: "Lista completa dei container",
            updating: "Aggiornamento...",
            headers: {
                containerNumber: "Numero Container",
                route: "Route",
                progress: "Progresso",
                status: "Stato",
                documentStatus: "Documenti",
                riskLevel: "Rischio",
                value: "Valore",
                createdAt: "Creato",
                actions: "Azioni",
            },
            view: "Visualizza",
            edit: "Modifica",
            delete: "Elimina",
            noContainers: {
                title: "Nessun container trovato",
                message: "Prova a modificare i filtri di ricerca",
                emptyMessage: "Inizia creando il tuo primo container",
                createFirst: "Crea il primo container",
            },
        },
        charts: {
            riskLevels: "Distribuzione Livelli di Rischio",
            containerStatus: "Distribuzione Stato Container",
            documentStatus: "Distribuzione Stato Documenti",
        },
    },
    form: {
        title: "Nuovo Container",
        editTitle: "Modifica Container",
        subtitle: "Crea un nuovo container",
        editSubtitle: "Modifica i dettagli del container",
        loading: "Caricamento container...",
        back: "Indietro",
        sections: {
            containerInfo: "Informazioni Container",
            route: "Rotta",
            order: "Ordine",
            receiver: "Ricevitore",
            value: "Valore",
        },
        fields: {
            containerNumber: "Container Number",
            containerNumberPlaceholder: "TCLU1234567",
            status: "Status",
            statusPlaceholder: "Seleziona status",
            routeFrom: "Da",
            routeFromPlaceholder: "New York, USA",
            routeTo: "A",
            routeToPlaceholder: "London, UK",
            eta: "ETA",
            shippingCompany: "Compagnia di Shipping",
            shippingCompanyPlaceholder: "Seleziona compagnia",
            receiver: "Receiver",
            receiverPlaceholder: "Seleziona receiver",
            amount: "Importo",
            amountPlaceholder: "125000",
            currency: "Valuta",
            currencyPlaceholder: "Seleziona valuta",
            orderId: "Order ID",
            orderIdPlaceholder: "Inserisci o seleziona Order ID",
            orderIdSelectExisting: "Seleziona da ordini esistenti",
            orderIdEnterManually: "Inserisci manualmente",
        },
        actions: {
            cancel: "Annulla",
            save: "Salva Modifiche",
            create: "Crea Container",
        },
        errors: {
            generic: "Si è verificato un errore durante il salvataggio del container",
            allFieldsRequired: "Tutti i campi sono obbligatori",
            amountInvalid: "L'importo deve essere un numero maggiore di 0",
            containerExists: "Un container con questo numero esiste già",
        },
        noReceivers: "Nessun receiver attivo disponibile. Invita un nuovo receiver per continuare.",
        selectReceiver: "Seleziona Receiver",
        notesOptional: "Note (opzionale)",
        notesPlaceholder: "Aggiungi una nota per il receiver...",
        selectedReceiver: "Receiver Selezionato",
        name: "Nome",
        email: "Email",
        country: "Paese",
        sendInvite: "Invia Invito",
    },
    detail: {
        back: "Torna ai Container",
        backToList: "Torna alla lista",
        loading: "Caricamento dettagli container...",
        notFound: {
            title: "Container non trovato",
            message: "Il container richiesto non esiste o non hai i permessi per visualizzarlo.",
        },
        actions: {
            uploadDocuments: "Carica Documenti",
            triage: "Triage",
            edit: "Modifica",
            share: "Condividi",
            delete: "Elimina",
        },
        confirmDeleteContainer: {
            title: "Elimina Container",
            message: "Sei sicuro di voler eliminare il container {{containerNumber}}? Questa azione non può essere annullata.",
            cancel: "Annulla",
            delete: "Elimina",
        },
        tabs: {
            overview: "Panoramica",
            info: "Informazioni",
            documents: "Documenti",
            timeline: "Timeline",
        },
        info: {
            containerInfo: "Informazioni Container",
            route: "Route",
            shipper: "Spedizioniere",
            receiver: "Receiver",
            from: "Da",
            to: "A",
            created: "Creato",
            expandMap: "Espandi mappa",
            collapseMap: "Riduci mappa",
            fields: {
                status: "Status",
                progress: "Progress",
                riskLevel: "Risk Level",
                documentStatus: "Doc Status",
                eta: "ETA",
                value: "Valore",
                shippingCompany: "Spedizioniere",
                country: "Paese",
            },
        },
        documents: {
            title: "Documenti",
            headers: {
                name: "Nome",
                type: "Tipo",
                status: "Status",
                uploaded: "Uploaded",
                actions: "Azioni",
            },
            actions: {
                view: "Visualizza",
                review: "Revisione",
                history: "Storico",
                download: "Download",
                delete: "Elimina",
            },
            confirmDelete: {
                title: "Elimina Documento",
                message: "Sei sicuro di voler eliminare questo documento? Questa azione non può essere annullata.",
                cancel: "Annulla",
                delete: "Elimina",
            },
            uploadInDevelopment: "Funzionalità di caricamento documenti in sviluppo",
            uploadDocument: "Carica Documento",
            discrepancies: {
                allCongruent: {
                    title: "Tutti i documenti sono congruenti",
                    message: "Le discrepanze sono state risolte con successo. Tutti gli attributi estratti dai documenti sono ora allineati e verificati.",
                    resetButton: "Reset discrepanze",
                    viewTriage: "Visualizza Triage",
                },
                detected: {
                    title: "Possibili discrepanze nei dati dei documenti",
                    message:
                        "Abbiamo rilevato incongruenze tra alcuni attributi estratti dai documenti di questo container. Ti consigliamo di procedere con il triage per verificarli e correggerli.",
                    goToTriage: "Vai al Triage Documenti",
                },
            },
        },
        timeline: {
            title: "Timeline Eventi",
            events: {
                containerCreated: "Container creato",
                statusChanged: "Status cambiato",
                documentsUploaded: "Documenti caricati",
                progressUpdated: "Progress aggiornato",
            },
            statusChangedFrom: "Status cambiato da",
            to: "a",
            documentsUploadedCount: "documenti caricati",
            progressUpdatedTo: "Progress aggiornato al",
        },
    },
    triage: {
        title: "Triage Documenti",
        subtitle: "Container",
        resolveWithAI: "Risolvi con AI",
        tabs: {
            matrix: "Matrice",
            visual: "Visual",
            raw: "Raw Data",
        },
        matrix: {
            attribute: "Attributo",
            ok: "OK",
            ko: "KO",
        },
        visual: {
            document: "Documento",
            check: "Check",
            ok: "OK",
        },
        raw: {
            json: "JSON",
            highlightDiscrepancies: "Highlight discrepanze",
        },
        modal: {
            title: "Risoluzione discrepanze con AI",
            analyzing: "Sto analizzando e correggendo gli attributi estratti…",
            completed: "Risoluzione completata",
            allResolved: "Tutte le discrepanze sono state risolte. Puoi chiudere questa finestra per vedere i risultati aggiornati.",
            close: "Chiudi",
        },
    },
    upload: {
        title: "Carica Documenti",
        subtitle: "Carica documenti per il container",
        loading: "Caricamento...",
        notFound: {
            title: "Container non trovato",
            message: "Il container richiesto non esiste.",
            backToList: "Torna alla lista",
        },
        fileTooLarge: "File {fileName} è troppo grande. Massimo 10MB consentiti.",
        selectAtLeastOne: "Seleziona almeno un file da caricare",
        documentType: "Tipo Documento",
        uploadSelected: "Carica Selezionati",
        cancel: "Annulla",
        confirmUpload: "Conferma Caricamento",
        uploadInProgress: "Caricamento in corso",
        uploadCompleted: "Caricamento completato",
        returnToDocuments: "Torna ai Documenti",
        removeFile: "Rimuovi file",
        selectFiles: "Seleziona File",
        selectedFiles: "File Selezionati",
        file: "file",
        files: "file",
        document: "documento",
        documents: "documenti",
        container: "Container",
        uploading: "Caricamento...",
        uploadedSuccessfully: "Caricato con successo",
        documentsUploadedSuccess: "Documenti caricati con successo!",
        documentsNowAvailable: "documento(i) sono stati caricati e sono ora disponibili nella sezione Documenti.",
        goToDocuments: "Vai ai Documenti",
        confirmUploadTitle: "Conferma Upload Documenti",
        unknownTypeWarning:
            'Alcuni documenti hanno tipo "Unknown Document". Questo significa che il sistema non è riuscito a identificare automaticamente il tipo di documento.',
        unknownTypeDocuments: "Documenti con tipo Unknown:",
        proceedAnyway: "Puoi procedere comunque con l'upload. I documenti potranno essere classificati manualmente in seguito.",
        proceedWithUpload: "Procedi con Upload",
    },
    worldMap: {
        title: "Mappa Rotte Mondiali",
        backToList: "Torna alla lista",
        updateInfo: "Il sistema controlla e aggiorna la posizione dei container periodicamente.",
        lastUpdate: "Ultimo aggiornamento",
        containerDetails: "Dettagli Container",
        viewFullDetails: "Vedi dettagli completi",
        showContainers: "Mostra Container",
        containerList: "Container nella Mappa",
        containerSingular: "container",
        containerPlural: "container",
    },
    receiver: {
        title: "Container Ricevuti",
        subtitle: "Gestisci i container ricevuti dagli spedizionieri",
        loading: "Caricamento container...",
        searchPlaceholder: "Cerca per container ID, route o spedizioniere...",
        shipperPlaceholder: "Filtra per spedizioniere",
        allShippers: "Tutti gli spedizionieri",
        description: "Lista completa dei container ricevuti",
        headers: {
            containerId: "Container ID",
            shipper: "Spedizioniere",
            route: "Route",
            shippingCompany: "Spedizioniere",
            progress: "Progress",
            eta: "ETA",
            status: "Status",
            docStatus: "Doc Status",
            riskLevel: "Risk Level",
            value: "Valore",
            actions: "Azioni",
        },
        noContainers: {
            title: "Nessun container trovato",
            message: "Prova a modificare i filtri di ricerca",
            emptyMessage: "Nessun container ricevuto ancora",
        },
        viewDetails: "Visualizza Dettagli",
        shipper: "Spedizioniere",
    },
};
